
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3LR0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ed587871ed2c33$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $RucgZ = parcelRequire("RucgZ");

var $5LJQo = parcelRequire("5LJQo");

var $bfVJZ = parcelRequire("bfVJZ");

var $afuOi = parcelRequire("afuOi");

var $6g5iY = parcelRequire("6g5iY");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $iCSbq = parcelRequire("iCSbq");

var $bngFq = parcelRequire("bngFq");

var $4PPZm = parcelRequire("4PPZm");

var $1lGo9 = parcelRequire("1lGo9");

var $lihoG = parcelRequire("lihoG");
const $11ed587871ed2c33$var$RenderMediaInline = ({ rendererAppearance: rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $5uXOq.useState)();
    const [fileState, setFileState] = (0, $5uXOq.useState)();
    const mediaClient = (0, $5uXOq.useContext)((0, $afuOi.MediaClientContext));
    const contextIdentifierProvider = (0, $5LJQo.useProvider)('contextIdentifierProvider');
    (0, $5uXOq.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $5uXOq.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $iCSbq.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $iCSbq.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $iCSbq.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
	 * Only show the loading view if the media client is not ready
	 * prevents calling the media API before the provider is ready
	 */ if (!mediaClient) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g5iY.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $iCSbq.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bfVJZ.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $iCSbq.mediaIdentifierMap).values())
        })
    }));
};
const $11ed587871ed2c33$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $5uXOq.useContext)((0, $afuOi.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4PPZm.ErrorBoundary), {
            component: (0, $1lGo9.ACTION_SUBJECT).RENDERER,
            componentId: (0, $lihoG.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RucgZ.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $afuOi.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($11ed587871ed2c33$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $11ed587871ed2c33$export$2e2bcd8739ae039 = (0, $8RXs9.default)($11ed587871ed2c33$var$MediaInline);

});
parcelRegister("RucgZ", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $996ec15ff699c55a$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");
var $8RXs9 = parcelRequire("8RXs9");

var $bngFq = parcelRequire("bngFq");

var $ibDPa = parcelRequire("ibDPa");
var $c6rYY = parcelRequire("c6rYY");

var $bgrr3 = parcelRequire("bgrr3");

var $afuOi = parcelRequire("afuOi");

var $e9EuB = parcelRequire("e9EuB");

var $k4vc3 = parcelRequire("k4vc3");

var $jCtEX = parcelRequire("jCtEX");

var $epAzP = parcelRequire("epAzP");

var $l92j0 = parcelRequire("l92j0");

var $38g7b = parcelRequire("38g7b");

var $bX1Xw = parcelRequire("bX1Xw");

var $4YEKF = parcelRequire("4YEKF");
const $996ec15ff699c55a$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $5uXOq.useState)();
    const [subscribeError, setSubscribeError] = (0, $5uXOq.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $5uXOq.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $5uXOq.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $i5FdW.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $c6rYY.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $ibDPa.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $ibDPa.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YEKF.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $jCtEX.messages).failedToUpload : (0, $jCtEX.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $c6rYY.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bX1Xw.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YEKF.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $c6rYY.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bX1Xw.InlineImageCardErrorView), {
                    message: formatMessage((0, $jCtEX.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bX1Xw.InlineImageCardErrorView), {
                    message: formatMessage((0, $jCtEX.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $c6rYY.MediaCardError)('metadata-fetch', new (0, $bgrr3.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bX1Xw.InlineImageCardErrorView), {
                    message: formatMessage((0, $jCtEX.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $afuOi.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l92j0.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bX1Xw.InlineImageCardErrorView), {
                    message: formatMessage((0, $jCtEX.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $5uXOq.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $5uXOq.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $epAzP.referenceHeights)['h1']),
            height: (0, $epAzP.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $5uXOq.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $5uXOq.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $k4vc3.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $5uXOq.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $5uXOq.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9EuB.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $38g7b.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $996ec15ff699c55a$export$fca833ae4278270f = (0, $8RXs9.default)($996ec15ff699c55a$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("ibDPa", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $009f564a9370b7dc$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $009f564a9370b7dc$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $009f564a9370b7dc$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $009f564a9370b7dc$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $009f564a9370b7dc$export$3bc90882cb04fda4);

var $aOycC = parcelRequire("aOycC");

var $c6rYY = parcelRequire("c6rYY");
const $009f564a9370b7dc$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $009f564a9370b7dc$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $aOycC.extractErrorInfo)(error)
        }
    };
};
const $009f564a9370b7dc$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $009f564a9370b7dc$export$d66a74eca3334206 = (fileState, error = new (0, $c6rYY.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $009f564a9370b7dc$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $009f564a9370b7dc$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $aOycC.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $009f564a9370b7dc$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $009f564a9370b7dc$export$95e48cf5f4b392a4(fileState);
    (0, $aOycC.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});
parcelRegister("aOycC", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $086bb9ad8bd5db0c$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $086bb9ad8bd5db0c$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $086bb9ad8bd5db0c$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $086bb9ad8bd5db0c$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $086bb9ad8bd5db0c$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $086bb9ad8bd5db0c$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $086bb9ad8bd5db0c$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $086bb9ad8bd5db0c$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $086bb9ad8bd5db0c$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $086bb9ad8bd5db0c$export$4d33ada3618f7626);

var $8CwRc = parcelRequire("8CwRc");

var $e4zSJ = parcelRequire("e4zSJ");

var $9Iej8 = parcelRequire("9Iej8");
const $086bb9ad8bd5db0c$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $086bb9ad8bd5db0c$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $086bb9ad8bd5db0c$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $086bb9ad8bd5db0c$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $086bb9ad8bd5db0c$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $086bb9ad8bd5db0c$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $086bb9ad8bd5db0c$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $086bb9ad8bd5db0c$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $086bb9ad8bd5db0c$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $086bb9ad8bd5db0c$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $086bb9ad8bd5db0c$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $086bb9ad8bd5db0c$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $086bb9ad8bd5db0c$export$4af9d71992e89714(error),
        error: $086bb9ad8bd5db0c$export$88c61dcad53762da(error),
        errorDetail: $086bb9ad8bd5db0c$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $086bb9ad8bd5db0c$export$29aa614726672b2e(error)
    };
};
const $086bb9ad8bd5db0c$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$086bb9ad8bd5db0c$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $086bb9ad8bd5db0c$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $086bb9ad8bd5db0c$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$086bb9ad8bd5db0c$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $086bb9ad8bd5db0c$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $086bb9ad8bd5db0c$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$086bb9ad8bd5db0c$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $086bb9ad8bd5db0c$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $086bb9ad8bd5db0c$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $086bb9ad8bd5db0c$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $e4zSJ.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $d400100cea308741$export$ec1779cb96554e1));
    }
}
const $086bb9ad8bd5db0c$export$4d33ada3618f7626 = (payload)=>{
    return (0, $9Iej8.default)((0, $d400100cea308741$export$ec1779cb96554e1))((0, $e4zSJ.sanitiseAnalyticsPayload)(payload));
};

});
const $d400100cea308741$export$ec1779cb96554e1 = 'media';

parcelRegister("e4zSJ", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $45323af7a7386c8b$export$e24d38cbdf73bc1a);

var $6CZ6k = parcelRequire("6CZ6k");

var $86xFr = parcelRequire("86xFr");
const $45323af7a7386c8b$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $45323af7a7386c8b$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $45323af7a7386c8b$export$e24d38cbdf73bc1a = (payload)=>$45323af7a7386c8b$var$hasFileAttributesWithFileId(payload) ? (0, $86xFr.produce)(payload, $45323af7a7386c8b$var$sanitiseFileId) : payload;

});


parcelRegister("c6rYY", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $7bd7b56f966c03ff$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $7bd7b56f966c03ff$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $7bd7b56f966c03ff$export$11f9f5835c5b9a04);
class $7bd7b56f966c03ff$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $7bd7b56f966c03ff$export$2c035820a31723e extends $7bd7b56f966c03ff$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $7bd7b56f966c03ff$export$10ab445310d30114 extends $7bd7b56f966c03ff$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $7bd7b56f966c03ff$export$18e89b7e50818288 extends $7bd7b56f966c03ff$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $7bd7b56f966c03ff$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $7bd7b56f966c03ff$export$d0a45ab59b4606b extends $7bd7b56f966c03ff$export$ec8d022824f41295 {
    constructor(source){
        super($7bd7b56f966c03ff$export$921ab4548acefaa4(source));
    }
}
function $7bd7b56f966c03ff$export$36b43e3dd9a92(err) {
    return err instanceof $7bd7b56f966c03ff$export$ec8d022824f41295;
}
const $7bd7b56f966c03ff$export$b380593ba3516c6f = (err)=>err instanceof $7bd7b56f966c03ff$export$2c035820a31723e;
const $7bd7b56f966c03ff$export$e1d87830b3784f94 = (err)=>err instanceof $7bd7b56f966c03ff$export$10ab445310d30114;
const $7bd7b56f966c03ff$export$443aeb298d35d79d = (err)=>$7bd7b56f966c03ff$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $7bd7b56f966c03ff$export$f00bb5a138da22e1(err) {
    return err instanceof $7bd7b56f966c03ff$export$d0a45ab59b4606b;
}
const $7bd7b56f966c03ff$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($7bd7b56f966c03ff$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $7bd7b56f966c03ff$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $7bd7b56f966c03ff$export$ec8d022824f41295(primaryReason, error);
};
const $7bd7b56f966c03ff$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});


parcelRegister("e9EuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8c1c3ef221aa89$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2JX77 = parcelRequire("2JX77");

var $4GEMb = parcelRequire("4GEMb");

const $ab8c1c3ef221aa89$var$MediaViewer = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("20Bir")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $ab8c1c3ef221aa89$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JX77.default), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4GEMb.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ab8c1c3ef221aa89$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("2JX77", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $ae87c4f3216d406b$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $ae87c4f3216d406b$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eusm9 = parcelRequire("eusm9");

var $6VxGE = parcelRequire("6VxGE");
const $ae87c4f3216d406b$export$442b7be89436c101 = '#101214';
const $ae87c4f3216d406b$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eusm9.default), {
        blankedColor: $ae87c4f3216d406b$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $ae87c4f3216d406b$export$2e2bcd8739ae039 = $ae87c4f3216d406b$var$ModalSpinner;

});
parcelRegister("eusm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c730fce022e9b71d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7LDRG = parcelRequire("7LDRG");

var $hYRVp = parcelRequire("hYRVp");

var $fHpHg = parcelRequire("fHpHg");
const $c730fce022e9b71d$var$ModalSpinner = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYRVp.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LDRG.default), {
        ...props
    });
var $c730fce022e9b71d$export$2e2bcd8739ae039 = $c730fce022e9b71d$var$ModalSpinner;

});
parcelRegister("7LDRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $536ca40708d41b9a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $b4a3S = parcelRequire("b4a3S");

var $clxo5 = parcelRequire("clxo5");

var $bWGt6 = parcelRequire("bWGt6");
function $536ca40708d41b9a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $536ca40708d41b9a$var$overlayZindex = (0, $b4a3S.layers).modal() + 10;
const $536ca40708d41b9a$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $536ca40708d41b9a$var$overlayZindex
});
$536ca40708d41b9a$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $536ca40708d41b9a$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$536ca40708d41b9a$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $536ca40708d41b9a$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $536ca40708d41b9a$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)($536ca40708d41b9a$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $536ca40708d41b9a$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($536ca40708d41b9a$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                size: "large",
                appearance: invertSpinnerColor || $536ca40708d41b9a$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("hYRVp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3fdcfb8d24a47e$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $clxo5 = parcelRequire("clxo5");
const $1c3fdcfb8d24a47e$var$blanketStyles = null;
const $1c3fdcfb8d24a47e$var$spinnerStyles = null;
const $1c3fdcfb8d24a47e$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1c3fdcfb8d24a47e$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $1c3fdcfb8d24a47e$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                size: "large",
                appearance: invertSpinnerColor || $1c3fdcfb8d24a47e$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("4GEMb", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $091c7147a3b8d078$export$51aee4c01b17acde);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5g2iQ = parcelRequire("5g2iQ");
const $091c7147a3b8d078$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("20Bir", function(module, exports) {

let $1768832940b9f163$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1768832940b9f163$var$load("cM9em"),
    $1768832940b9f163$var$load("fr9NE"),
    $1768832940b9f163$var$load("h2MrD"),
    $1768832940b9f163$var$load("bYT2S"),
    $1768832940b9f163$var$load("bqFpG")
]).then(()=>parcelRequire('lSJ55'));

});


parcelRegister("jCtEX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6cf31e0cd3e665e4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6cf31e0cd3e665e4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unableToLoadContent: {
        id: 'fabric.editor.unableToLoadContent',
        defaultMessage: "We couldn't load this content",
        description: 'Display this message when there is an error loading file content'
    },
    failedToUpload: {
        id: 'fabric.editor.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'Display this message when there is an error uploading a file'
    }
});

});

parcelRegister("l92j0", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $d1c37c9053fa21ee$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5dnAb = parcelRequire("5dnAb");

var $iiqs8 = parcelRequire("iiqs8");

var $lqrTe = parcelRequire("lqrTe");

var $4YEKF = parcelRequire("4YEKF");
const $d1c37c9053fa21ee$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $5uXOq.useMemo)(()=>({
            traceId: (0, $5dnAb.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $iiqs8.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YEKF.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lqrTe.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $f8Sb3.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("iiqs8", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $b6fe8f09e02f17e8$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $aTfy3 = parcelRequire("aTfy3");
var $8CwRc = parcelRequire("8CwRc");

var $8bsur = parcelRequire("8bsur");
var $7mTji = parcelRequire("7mTji");
var $afuOi = parcelRequire("afuOi");

var $4xFVv = parcelRequire("4xFVv");

var $6hfpA = parcelRequire("6hfpA");

var $fe4Nk = parcelRequire("fe4Nk");

var $cmmUZ = parcelRequire("cmmUZ");
var $aL39c = parcelRequire("aL39c");
var $dNyIg = parcelRequire("dNyIg");

var $eauHk = parcelRequire("eauHk");
var $dHCPu = parcelRequire("dHCPu");

var $jNqxf = parcelRequire("jNqxf");
const $b6fe8f09e02f17e8$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $afuOi.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $jNqxf.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $jNqxf.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $dNyIg.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $dHCPu.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $cmmUZ.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $6hfpA.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $7mTji.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $aTfy3.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $fe4Nk.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $fe4Nk.MediaFilePreviewError)('metadata-fetch', (0, $8CwRc.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $jNqxf.useCurrentValueRef)(()=>{
        return (0, $cmmUZ.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $jNqxf.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $jNqxf.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $dNyIg.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $jNqxf.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $aL39c.isSupportedLocalPreview)(mediaType) && (0, $4xFVv.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $cmmUZ.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $jNqxf.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $cmmUZ.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $fe4Nk.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $cmmUZ.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $6hfpA.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $cmmUZ.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $6hfpA.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $6hfpA.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $cmmUZ.isLocalPreview)(failedPreview);
        const isRemote = (0, $cmmUZ.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $fe4Nk.ImageLoadError)(failedPreview?.source);
            (0, $dNyIg.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $cmmUZ.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $cmmUZ.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $eauHk.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $8bsur.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("8bsur", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $1232176b670c2bb4$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $fHpHg = parcelRequire("fHpHg");

var $afuOi = parcelRequire("afuOi");

var $agk1j = parcelRequire("agk1j");

var $5YZRA = parcelRequire("5YZRA");
function $1232176b670c2bb4$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $1232176b670c2bb4$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $afuOi.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const registerCopyIntentRef = $1232176b670c2bb4$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $agk1j.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $agk1j.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $fHpHg.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('platform_media_cross_client_copy')) (0, $5YZRA.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $5YZRA.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("agk1j", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $1073d08478502ff8$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $1073d08478502ff8$export$aacb463551da2e8f);

var $3sO2v = parcelRequire("3sO2v");
const $1073d08478502ff8$var$getRequestErrorDetails = (err)=>{
    if ((0, $3sO2v.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $1073d08478502ff8$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $3sO2v.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$1073d08478502ff8$var$getRequestErrorDetails(error)
        }
    };
};
const $1073d08478502ff8$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("5YZRA", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $db96098d067f050b$export$f65ca476c09acec0);
const $db96098d067f050b$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("7mTji", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $3827e2484cd0d606$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $afuOi = parcelRequire("afuOi");

var $bvBMr = parcelRequire("bvBMr");
function $3827e2484cd0d606$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $afuOi.useMediaClient)();
    const fileState = (0, $bvBMr.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("bvBMr", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $0e8e4b1eca9a88eb$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $afuOi = parcelRequire("afuOi");
const $0e8e4b1eca9a88eb$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $0e8e4b1eca9a88eb$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $afuOi.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $0e8e4b1eca9a88eb$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("6hfpA", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $4a403a21b8b81f78$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $4a403a21b8b81f78$export$768c370ed0dbaeb3);

var $8CwRc = parcelRequire("8CwRc");

var $fe4Nk = parcelRequire("fe4Nk");
const $4a403a21b8b81f78$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $4a403a21b8b81f78$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $4a403a21b8b81f78$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $4a403a21b8b81f78$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $8CwRc.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $4a403a21b8b81f78$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $4a403a21b8b81f78$export$4af9d71992e89714(error),
        error: $4a403a21b8b81f78$export$88c61dcad53762da(error),
        errorDetail: $4a403a21b8b81f78$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $4a403a21b8b81f78$export$29aa614726672b2e(error)
    };
};
const $4a403a21b8b81f78$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$4a403a21b8b81f78$export$74aaf4784c2edb2c(new (0, $fe4Nk.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("fe4Nk", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $f20623ae78adc8f7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $f20623ae78adc8f7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $f20623ae78adc8f7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $f20623ae78adc8f7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $f20623ae78adc8f7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $f20623ae78adc8f7$export$7156ce7b78b49bd7);
class $f20623ae78adc8f7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $f20623ae78adc8f7$export$2c035820a31723e extends $f20623ae78adc8f7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f20623ae78adc8f7$export$10ab445310d30114 extends $f20623ae78adc8f7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f20623ae78adc8f7$export$18e89b7e50818288 extends $f20623ae78adc8f7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $f20623ae78adc8f7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $f20623ae78adc8f7$export$d0a45ab59b4606b extends $f20623ae78adc8f7$export$96e559194c287cf4 {
    constructor(source){
        super($f20623ae78adc8f7$var$getImageLoadPrimaryReason(source));
    }
}
function $f20623ae78adc8f7$export$553696a6e769784c(err) {
    return err instanceof $f20623ae78adc8f7$export$96e559194c287cf4;
}
const $f20623ae78adc8f7$export$b380593ba3516c6f = (err)=>err instanceof $f20623ae78adc8f7$export$2c035820a31723e;
const $f20623ae78adc8f7$export$e1d87830b3784f94 = (err)=>err instanceof $f20623ae78adc8f7$export$10ab445310d30114;
const $f20623ae78adc8f7$export$443aeb298d35d79d = (err)=>$f20623ae78adc8f7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $f20623ae78adc8f7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($f20623ae78adc8f7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $f20623ae78adc8f7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $f20623ae78adc8f7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("cmmUZ", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $ccc87318e8778ca2$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $ccc87318e8778ca2$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $ccc87318e8778ca2$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $ccc87318e8778ca2$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $ccc87318e8778ca2$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $ccc87318e8778ca2$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $ccc87318e8778ca2$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $ccc87318e8778ca2$export$98e935d981c884d);

var $0cozz = parcelRequire("0cozz");

var $fe4Nk = parcelRequire("fe4Nk");

var $dNyIg = parcelRequire("dNyIg");

var $aL39c = parcelRequire("aL39c");
const $ccc87318e8778ca2$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $0cozz.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $dNyIg.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $ccc87318e8778ca2$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $0cozz.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $fe4Nk.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $ccc87318e8778ca2$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $ccc87318e8778ca2$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $ccc87318e8778ca2$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $ccc87318e8778ca2$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $ccc87318e8778ca2$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $ccc87318e8778ca2$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $aL39c.getRemotePreview)(mediaClient, id, params, traceContext);
    return $ccc87318e8778ca2$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $ccc87318e8778ca2$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $aL39c.getLocalPreview)(filePreview);
    return $ccc87318e8778ca2$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("0cozz", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $1606d64a603a795d$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $1606d64a603a795d$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $1606d64a603a795d$export$e51a8146182600b8);
const $1606d64a603a795d$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $1606d64a603a795d$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$1606d64a603a795d$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $1606d64a603a795d$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $1606d64a603a795d$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $1606d64a603a795d$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $1606d64a603a795d$var$getStringFromParams(params, 'collection'),
        alt: $1606d64a603a795d$var$getStringFromParams(params, 'alt'),
        height: $1606d64a603a795d$var$getNumberFromParams(params, 'height'),
        width: $1606d64a603a795d$var$getNumberFromParams(params, 'width'),
        size: $1606d64a603a795d$var$getNumberFromParams(params, 'size'),
        name: $1606d64a603a795d$var$getStringFromParams(params, 'name'),
        mimeType: $1606d64a603a795d$var$getStringFromParams(params, 'mimeType')
    };
};
const $1606d64a603a795d$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $1606d64a603a795d$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$1606d64a603a795d$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $1606d64a603a795d$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("dNyIg", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $c076762e0e178dca$export$b7e8ee3f7a41459);

var $fteJ7 = parcelRequire("fteJ7");
const $c076762e0e178dca$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $c076762e0e178dca$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $c076762e0e178dca$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $c076762e0e178dca$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $c076762e0e178dca$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $c076762e0e178dca$export$b7e8ee3f7a41459 = new $c076762e0e178dca$export$7b50526c091bb915((0, $fteJ7.createObjectURLCache)());

});
parcelRegister("fteJ7", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $285f8367c32fc122$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $285f8367c32fc122$export$36d0f9859761643d = 50;
class $285f8367c32fc122$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $285f8367c32fc122$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $285f8367c32fc122$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $285f8367c32fc122$export$ba71be67d5c32535 = ()=>new $285f8367c32fc122$export$75d1c8c9ba1d0773($285f8367c32fc122$export$36d0f9859761643d);

});


parcelRegister("aL39c", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $a60e4c7fc7fcf222$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $a60e4c7fc7fcf222$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $a60e4c7fc7fcf222$export$bfe20bd01db02b3);

var $9hbur = parcelRequire("9hbur");

var $03cY2 = parcelRequire("03cY2");

var $fe4Nk = parcelRequire("fe4Nk");

var $dQXgx = parcelRequire("dQXgx");
const $a60e4c7fc7fcf222$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $a60e4c7fc7fcf222$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $03cY2.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $fe4Nk.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $a60e4c7fc7fcf222$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $dQXgx.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $fe4Nk.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $a60e4c7fc7fcf222$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $fe4Nk.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $9hbur.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $a60e4c7fc7fcf222$var$getImageLocalPreview(value);
            case 'video':
                return $a60e4c7fc7fcf222$var$getVideoLocalPreview(value);
            default:
                throw new (0, $fe4Nk.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $fe4Nk.LocalPreviewError)('local-preview-unsupported');
};
const $a60e4c7fc7fcf222$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $fe4Nk.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("03cY2", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $889f21974eb9e12d$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $889f21974eb9e12d$export$67689507e8404821);

var $8YmTT = parcelRequire("8YmTT");

var $3dlAk = parcelRequire("3dlAk");

var $geTcb = parcelRequire("geTcb");

var $190Py = parcelRequire("190Py");
const { Orientation: $889f21974eb9e12d$var$Orientation, XResolution: $889f21974eb9e12d$var$XResolution } = (0, $8YmTT.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $889f21974eb9e12d$var$DPI_WEB_BASELINE = 72;
async function $889f21974eb9e12d$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $889f21974eb9e12d$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $889f21974eb9e12d$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $889f21974eb9e12d$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $889f21974eb9e12d$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $889f21974eb9e12d$var$DPI_WEB_BASELINE;
        else return $889f21974eb9e12d$export$268f92356524130b(tags, $889f21974eb9e12d$var$XResolution, $889f21974eb9e12d$var$DPI_WEB_BASELINE) / $889f21974eb9e12d$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $889f21974eb9e12d$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$889f21974eb9e12d$var$Orientation]) {
        const tagValue = tags[$889f21974eb9e12d$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $8YmTT.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $889f21974eb9e12d$export$67689507e8404821(file) {
    const tags = await (0, $3dlAk.readImageMetaTags)(file);
    return $889f21974eb9e12d$var$getOrientationFromTags(tags);
}
function $889f21974eb9e12d$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $889f21974eb9e12d$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $889f21974eb9e12d$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $3dlAk.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $889f21974eb9e12d$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $889f21974eb9e12d$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $geTcb.loadImage)(src);
        const { width: width, height: height } = (0, $geTcb.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("8YmTT", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $e125adffcf53d9a6$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $e125adffcf53d9a6$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $e125adffcf53d9a6$export$f6ea0c89fd7d156);
var $e125adffcf53d9a6$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $e125adffcf53d9a6$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $e125adffcf53d9a6$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("3dlAk", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $5096daba092fed1d$export$41982b5c7acb23c4);

var $8YmTT = parcelRequire("8YmTT");

var $6splK = parcelRequire("6splK");

var $lHSUK = parcelRequire("lHSUK");

var $hprpt = parcelRequire("hprpt");
async function $5096daba092fed1d$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $8YmTT.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $lHSUK.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $hprpt.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $8YmTT.ImageType).JPEG) return await (0, $6splK.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("6splK", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $fbbeb434401d3943$export$556b2ccec62d7f2a);

var $8YmTT = parcelRequire("8YmTT");
const { XResolution: $fbbeb434401d3943$var$XResolution, YResolution: $fbbeb434401d3943$var$YResolution } = (0, $8YmTT.SupportedImageMetaTag);
let $fbbeb434401d3943$var$loadImage;

function $fbbeb434401d3943$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$fbbeb434401d3943$var$loadImage) {
            const module = await (parcelRequire("8iz07"));
            $fbbeb434401d3943$var$loadImage = module.default || module;
        }
        $fbbeb434401d3943$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $fbbeb434401d3943$var$XResolution || key === $fbbeb434401d3943$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8iz07", function(module, exports) {

let $60ab27a2818ad2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60ab27a2818ad2da$var$load("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("lHSUK", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $4b992d2fa5b375a6$export$5fb37736440fca6f);

var $geTcb = parcelRequire("geTcb");
let $4b992d2fa5b375a6$var$pngChunksExtract;

async function $4b992d2fa5b375a6$export$5fb37736440fca6f(file) {
    if (!$4b992d2fa5b375a6$var$pngChunksExtract) {
        const module = await (parcelRequire("8u6C4"));
        $4b992d2fa5b375a6$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $geTcb.fileToArrayBuffer)(file);
    const chunks = $4b992d2fa5b375a6$var$pngChunksExtract(buffer);
    return await $4b992d2fa5b375a6$export$9185743fdd58ce45(chunks);
}
async function $4b992d2fa5b375a6$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("geTcb", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $456284a9b1965f98$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $456284a9b1965f98$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $456284a9b1965f98$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $456284a9b1965f98$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $456284a9b1965f98$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $456284a9b1965f98$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $456284a9b1965f98$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $456284a9b1965f98$export$61a1de0822e2820);

var $kQFYg = parcelRequire("kQFYg");

var $6LFfW = parcelRequire("6LFfW");

var $keUOR = parcelRequire("keUOR");

var $asG7N = parcelRequire("asG7N");

var $id8bM = parcelRequire("id8bM");

var $3RFvL = parcelRequire("3RFvL");

var $f4IUb = parcelRequire("f4IUb");

var $5U2qg = parcelRequire("5U2qg");

var $ivUrz = parcelRequire("ivUrz");

var $iss0x = parcelRequire("iss0x");

var $jAQok = parcelRequire("jAQok");

var $3UE4V = parcelRequire("3UE4V");

var $1MHPt = parcelRequire("1MHPt");

var $b8BsB = parcelRequire("b8BsB");

var $jv4ms = parcelRequire("jv4ms");

var $b6ueF = parcelRequire("b6ueF");
function $456284a9b1965f98$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $456284a9b1965f98$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $456284a9b1965f98$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $456284a9b1965f98$export$849633012686f7ee(file)
    };
}
async function $456284a9b1965f98$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $456284a9b1965f98$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $456284a9b1965f98$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $456284a9b1965f98$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $456284a9b1965f98$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $456284a9b1965f98$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $456284a9b1965f98$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kQFYg)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ivUrz)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jAQok)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ivUrz)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iss0x)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5U2qg)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($asG7N)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b8BsB)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($keUOR)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6LFfW)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1MHPt)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3UE4V)))
    }
];
function $456284a9b1965f98$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $456284a9b1965f98$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $b6ueF.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jv4ms)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($id8bM)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3RFvL)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f4IUb)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("kQFYg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f2d93887483eb5c8$var$_react = $f2d93887483eb5c8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $f2d93887483eb5c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f2d93887483eb5c8$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $f2d93887483eb5c8$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f2d93887483eb5c8$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $f2d93887483eb5c8$var$_default = module.exports.default = $f2d93887483eb5c8$var$PdfDocument24Icon;

});

parcelRegister("6LFfW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4ed72272ecec471f$var$_react = $4ed72272ecec471f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $4ed72272ecec471f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ed72272ecec471f$var$Gif24Icon = (props)=>/*#__PURE__*/ $4ed72272ecec471f$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4ed72272ecec471f$var$Gif24Icon.displayName = 'Gif24Icon';
var $4ed72272ecec471f$var$_default = module.exports.default = $4ed72272ecec471f$var$Gif24Icon;

});

parcelRegister("keUOR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ebc130931ce253ae$var$_react = $ebc130931ce253ae$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $ebc130931ce253ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ebc130931ce253ae$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $ebc130931ce253ae$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ebc130931ce253ae$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $ebc130931ce253ae$var$_default = module.exports.default = $ebc130931ce253ae$var$PowerpointPresentation24Icon;

});

parcelRegister("asG7N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $79dd31ff27926fe6$var$_react = $79dd31ff27926fe6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $79dd31ff27926fe6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79dd31ff27926fe6$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $79dd31ff27926fe6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$79dd31ff27926fe6$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $79dd31ff27926fe6$var$_default = module.exports.default = $79dd31ff27926fe6$var$WordDocument24Icon;

});

parcelRegister("id8bM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $036bde1d0a6ad9e8$var$_react = $036bde1d0a6ad9e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $036bde1d0a6ad9e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $036bde1d0a6ad9e8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $036bde1d0a6ad9e8$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$036bde1d0a6ad9e8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $036bde1d0a6ad9e8$var$_default = module.exports.default = $036bde1d0a6ad9e8$var$Sketch24Icon;

});

parcelRegister("3RFvL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2d06859c295e262a$var$_react = $2d06859c295e262a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $2d06859c295e262a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2d06859c295e262a$var$Figma24Icon = (props)=>/*#__PURE__*/ $2d06859c295e262a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2d06859c295e262a$var$Figma24Icon.displayName = 'Figma24Icon';
var $2d06859c295e262a$var$_default = module.exports.default = $2d06859c295e262a$var$Figma24Icon;

});

parcelRegister("f4IUb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $af9a0ff2a98f8599$var$_react = $af9a0ff2a98f8599$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $af9a0ff2a98f8599$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $af9a0ff2a98f8599$var$Executable24Icon = (props)=>/*#__PURE__*/ $af9a0ff2a98f8599$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$af9a0ff2a98f8599$var$Executable24Icon.displayName = 'Executable24Icon';
var $af9a0ff2a98f8599$var$_default = module.exports.default = $af9a0ff2a98f8599$var$Executable24Icon;

});

parcelRegister("5U2qg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $44c40fcb84f9c702$var$_react = $44c40fcb84f9c702$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $44c40fcb84f9c702$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $44c40fcb84f9c702$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $44c40fcb84f9c702$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$44c40fcb84f9c702$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $44c40fcb84f9c702$var$_default = module.exports.default = $44c40fcb84f9c702$var$GoogleDoc24Icon;

});

parcelRegister("ivUrz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d7a6e7c872d372c4$var$_react = $d7a6e7c872d372c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $d7a6e7c872d372c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d7a6e7c872d372c4$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $d7a6e7c872d372c4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d7a6e7c872d372c4$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $d7a6e7c872d372c4$var$_default = module.exports.default = $d7a6e7c872d372c4$var$GoogleForm24Icon;

});

parcelRegister("iss0x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d700913e82fa94ae$var$_react = $d700913e82fa94ae$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $d700913e82fa94ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d700913e82fa94ae$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $d700913e82fa94ae$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d700913e82fa94ae$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $d700913e82fa94ae$var$_default = module.exports.default = $d700913e82fa94ae$var$GoogleSheet24Icon;

});

parcelRegister("jAQok", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e43a04f0afb01160$var$_react = $e43a04f0afb01160$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $e43a04f0afb01160$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e43a04f0afb01160$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $e43a04f0afb01160$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e43a04f0afb01160$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $e43a04f0afb01160$var$_default = module.exports.default = $e43a04f0afb01160$var$GoogleSlide24Icon;

});

parcelRegister("3UE4V", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2d95b0cccddd647d$var$_react = $2d95b0cccddd647d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $2d95b0cccddd647d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2d95b0cccddd647d$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $2d95b0cccddd647d$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2d95b0cccddd647d$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $2d95b0cccddd647d$var$_default = module.exports.default = $2d95b0cccddd647d$var$ExcelSpreadsheet24Icon;

});

parcelRegister("1MHPt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $14cc45bb7721835b$var$_react = $14cc45bb7721835b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $14cc45bb7721835b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $14cc45bb7721835b$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $14cc45bb7721835b$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$14cc45bb7721835b$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $14cc45bb7721835b$var$_default = module.exports.default = $14cc45bb7721835b$var$Spreadsheet24Icon;

});

parcelRegister("b8BsB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $81bd7fe640fd8a00$var$_react = $81bd7fe640fd8a00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $81bd7fe640fd8a00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $81bd7fe640fd8a00$var$Presentation24Icon = (props)=>/*#__PURE__*/ $81bd7fe640fd8a00$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$81bd7fe640fd8a00$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $81bd7fe640fd8a00$var$_default = module.exports.default = $81bd7fe640fd8a00$var$Presentation24Icon;

});

parcelRegister("jv4ms", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e3244b9a58b70edc$var$_react = $e3244b9a58b70edc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $e3244b9a58b70edc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e3244b9a58b70edc$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $e3244b9a58b70edc$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e3244b9a58b70edc$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $e3244b9a58b70edc$var$_default = module.exports.default = $e3244b9a58b70edc$var$SourceCode24Icon;

});

parcelRegister("b6ueF", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $00c4d8a4baad0a13$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $00c4d8a4baad0a13$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $00c4d8a4baad0a13$export$ba4368c844580f9e);
function $00c4d8a4baad0a13$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $00c4d8a4baad0a13$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $00c4d8a4baad0a13$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $00c4d8a4baad0a13$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $00c4d8a4baad0a13$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $00c4d8a4baad0a13$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $00c4d8a4baad0a13$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("8u6C4", function(module, exports) {

let $019819d3d04dcea8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $019819d3d04dcea8$var$load("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("hprpt", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $fcd0194d43fb5d52$export$55c3bc9841b19de2);
function $fcd0194d43fb5d52$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("190Py", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $3d79233dd07bac74$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $3d79233dd07bac74$export$43142f95b8de7a91);
const $3d79233dd07bac74$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $3d79233dd07bac74$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $3d79233dd07bac74$export$43142f95b8de7a91 = (orientation)=>{
    return $3d79233dd07bac74$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("dQXgx", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $31f6fbd725102e33$export$4269d30173168e5c);
const $31f6fbd725102e33$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("eauHk", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $4c1d06ba0318ead8$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $4c1d06ba0318ead8$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $4c1d06ba0318ead8$export$de7c49925e44d75d);

var $6BmkP = parcelRequire("6BmkP");
const $4c1d06ba0318ead8$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $4c1d06ba0318ead8$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $4c1d06ba0318ead8$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $4c1d06ba0318ead8$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $4c1d06ba0318ead8$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $4c1d06ba0318ead8$var$dashed = (param)=>param ? `-${param}` : '';
const $4c1d06ba0318ead8$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$4c1d06ba0318ead8$var$dashed(collectionName)}${$4c1d06ba0318ead8$var$dashed(occurrenceKey)}`;
const $4c1d06ba0318ead8$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $4c1d06ba0318ead8$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $4c1d06ba0318ead8$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $6BmkP.printFunctionCall)($4c1d06ba0318ead8$export$4310981e0aa4ce67, $4c1d06ba0318ead8$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $6BmkP.printScript)([
        $4c1d06ba0318ead8$export$ede93d4564eaa8da.toString(),
        $4c1d06ba0318ead8$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $4c1d06ba0318ead8$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $4c1d06ba0318ead8$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("6BmkP", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $9db0415f610f88cc$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $9db0415f610f88cc$export$8b902fb69a2f17c1);

var $fHpHg = parcelRequire("fHpHg");
const $9db0415f610f88cc$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $9db0415f610f88cc$var$printParams = (args)=>args.map((arg)=>$9db0415f610f88cc$var$printParam(arg)).join(',');
const $9db0415f610f88cc$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$9db0415f610f88cc$var$printParams(args)});`;
const $9db0415f610f88cc$export$8b902fb69a2f17c1 = (statements)=>(0, $fHpHg.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("dHCPu", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $4bc72e58be39eb81$export$d3a890b0f7844b6f);

var $eauHk = parcelRequire("eauHk");
const $4bc72e58be39eb81$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $eauHk.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $eauHk.getKey)(identifier)];
};

});

parcelRegister("jNqxf", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $f6463842b9e4a391$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f6463842b9e4a391$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f6463842b9e4a391$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $f6463842b9e4a391$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f6463842b9e4a391$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f6463842b9e4a391$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f6463842b9e4a391$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f6463842b9e4a391$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("lqrTe", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $52039294039e9671$export$1f97dc1e9d072692);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $7IJqF = parcelRequire("7IJqF");

var $4f8Fi = parcelRequire("4f8Fi");

var $190Py = parcelRequire("190Py");

var $3Du7S = parcelRequire("3Du7S");
const $52039294039e9671$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $5uXOq.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $5uXOq.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $5uXOq.useState)(false);
    const imgRef = (0, $5uXOq.useRef)(null);
    const imageRef = (0, $5uXOq.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $190Py.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $190Py.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4f8Fi.ImageComponent), {
        loading: loading,
        "data-testid": "media-image",
        "data-vc": "media-image",
        draggable: false,
        alt: alt,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onLoad: imageLoadHandler,
        onError: onImageError,
        imageRef: mergedRef,
        src: dataURI,
        crossOrigin: crossOrigin,
        ...(0, $fHpHg.fg)('platform_exclude_media_offender_from_vc') && (0, $7IJqF.VcMediaWrapperProps)
    });
});

});
parcelRegister("4f8Fi", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $6a2fde3d461f7060$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $6a2fde3d461f7060$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $6a2fde3d461f7060$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$6a2fde3d461f7060$var$imgStyle,
            ...style
        }
    }));
};

});


parcelRegister("4YEKF", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $68c79df4ac28146f$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $clxo5 = parcelRequire("clxo5");


var $a1Rfx = parcelRequire("a1Rfx");
const $68c79df4ac28146f$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $2e7acaf3dccf31c4$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a1Rfx.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $clxo5.default), {
        size: height > (0, $2e7acaf3dccf31c4$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
/** Height threshold that determines icon size to be small or medium */ const $2e7acaf3dccf31c4$export$88e3664eef60c981 = 24;

parcelRegister("a1Rfx", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $98b3a6c7ad3f4a08$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eUrAh = parcelRequire("eUrAh");
const $98b3a6c7ad3f4a08$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $eUrAh.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("eUrAh", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $1007b42b9634914e$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $1007b42b9634914e$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("38g7b", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $604e7f63f5e44853$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $i5S4t = parcelRequire("i5S4t");

var $cNjQn = parcelRequire("cNjQn");
function $604e7f63f5e44853$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $604e7f63f5e44853$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $604e7f63f5e44853$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $cNjQn.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $cNjQn.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $i5S4t.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $cNjQn.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cNjQn.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $cNjQn.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $cNjQn.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $cNjQn.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $604e7f63f5e44853$var$sizeWrapperStyle
    }, children)));
};

});
parcelRegister("i5S4t", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $f48d5ebcaa78a483$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $f48d5ebcaa78a483$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $f48d5ebcaa78a483$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $f48d5ebcaa78a483$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});


parcelRegister("bX1Xw", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $9e711ff614c42d12$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $85eFT = parcelRequire("85eFT");

var $5KCCi = parcelRequire("5KCCi");


var $a1Rfx = parcelRequire("a1Rfx");

var $lsa15 = parcelRequire("lsa15");
const $9e711ff614c42d12$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $2e7acaf3dccf31c4$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a1Rfx.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5KCCi.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lsa15.IconWrapper), null, icon || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        label: "error",
        LEGACY_size: height > (0, $2e7acaf3dccf31c4$export$88e3664eef60c981) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("lsa15", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $be404e730ae46170$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $be404e730ae46170$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $be404e730ae46170$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $be404e730ae46170$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $be404e730ae46170$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("bfVJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2998bf3171d1d9a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6g5iY = parcelRequire("6g5iY");

var $htBRZ = parcelRequire("htBRZ");



class $f2998bf3171d1d9a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'MediaInlineCardLoader';
    }
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("5fQ00")),
                (parcelRequire("cqis9")),
                (parcelRequire("6WBjI"))
            ]);
            $f2998bf3171d1d9a$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $f2998bf3171d1d9a$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $f2998bf3171d1d9a$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $f2998bf3171d1d9a$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g5iY.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            MediaInlineCard: $f2998bf3171d1d9a$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $f2998bf3171d1d9a$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}

});
parcelRegister("6g5iY", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $6ed66af7547937d0$export$4449fcbb2ad61ad1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4YZQK = parcelRequire("4YZQK");

var $clxo5 = parcelRequire("clxo5");

var $b5T1I = parcelRequire("b5T1I");

var $D38LN = parcelRequire("D38LN");

var $l3zxN = parcelRequire("l3zxN");
class $6ed66af7547937d0$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4YZQK.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $l3zxN.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $D38LN.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4YZQK.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b5T1I.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $D38LN.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("4YZQK", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $1e7a38ef4eb4fc75$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a7ExS = parcelRequire("a7ExS");
class $1e7a38ef4eb4fc75$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a7ExS.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("a7ExS", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $dd43cb4df4d968f7$export$e6dfd72ab29f8598);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aHSbY = parcelRequire("aHSbY");

var $gGllj = parcelRequire("gGllj");

var $fHpHg = parcelRequire("fHpHg");
const $dd43cb4df4d968f7$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gGllj.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aHSbY.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("aHSbY", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $3227f0645118bf77$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $3227f0645118bf77$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $a7f8c6b391092279$export$e62e8919cca44969)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $3227f0645118bf77$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $3227f0645118bf77$var$selected;
    else return 'user-select: text';
};
const $3227f0645118bf77$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $a7f8c6b391092279$export$fbda843f0a27fe96)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$3227f0645118bf77$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $a7f8c6b391092279$export$46987b49aab6d1a8)})`
    }
});

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';


parcelRegister("gGllj", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $249b38b818a7b379$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $249b38b818a7b379$var$selectedStyles = null;
const $249b38b818a7b379$var$notSelectedStyles = null;
const $249b38b818a7b379$var$wrapperStyles = null;
const $249b38b818a7b379$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazj3m3 _bfhk155y _1rkwglyw _80omtlke _irr3u9me",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs1s9b _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv"
        ]),
        children: children
    });

});



parcelRegister("b5T1I", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $3229d53bc95d37df$export$d34be4d513116847);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $5qxCG = parcelRequire("5qxCG");

var $l3zxN = parcelRequire("l3zxN");

var $c95g7 = parcelRequire("c95g7");
class $3229d53bc95d37df$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qxCG.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.IconWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c95g7))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $l3zxN.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3zxN.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("5qxCG", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $2c59f81dd874cff4$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $2c59f81dd874cff4$export$a201b065fc2e76a1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eF8ll = parcelRequire("eF8ll");

var $9y4rj = parcelRequire("9y4rj");

var $fHpHg = parcelRequire("fHpHg");
const $2c59f81dd874cff4$export$f04a61298a47a40f = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9y4rj.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eF8ll.Icon), {
        ...props
    });
const $2c59f81dd874cff4$export$a201b065fc2e76a1 = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9y4rj.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eF8ll.AKIconWrapper), {
        ...props
    });

});
parcelRegister("eF8ll", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $db786f7e44dd0f32$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $db786f7e44dd0f32$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $db786f7e44dd0f32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db786f7e44dd0f32$export$f04a61298a47a40f = /*#__PURE__*/ (0, $bWGt6.default)("img", {
    target: "ebf58rv1"
})({
    name: "15ahtvm",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
const $db786f7e44dd0f32$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ebf58rv0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});

});

parcelRegister("9y4rj", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $6ac79a657ddf1926$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $6ac79a657ddf1926$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6ac79a657ddf1926$var$iconStyles = null;
const $6ac79a657ddf1926$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt || '',
        ...props,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    });
// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $6ac79a657ddf1926$var$akIconWrapperStyles = null;
const $6ac79a657ddf1926$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("l3zxN", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $fb879bfd3706530b$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $fb879bfd3706530b$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $fb879bfd3706530b$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $fb879bfd3706530b$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $fb879bfd3706530b$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $fb879bfd3706530b$export$ddce81e032b0736e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7lSuy = parcelRequire("7lSuy");

var $gBGO5 = parcelRequire("gBGO5");

var $fHpHg = parcelRequire("fHpHg");
const $fb879bfd3706530b$export$be58b4326e23250f = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.IconWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$e31a6cc0a4c97f0e = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.EmojiWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$c73a53738ef9e3f = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.IconTitleWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$75180efdd3f4d9c2 = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.LozengeWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$a16269f205a2f280 = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.LozengeBlockWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$91b164375b8037b5 = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.RightIconPositionWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$7291f9f954790243 = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.IconPositionWrapper), {
        ...props
    });
const $fb879bfd3706530b$export$ddce81e032b0736e = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gBGO5.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lSuy.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("7lSuy", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $59f00aac3a3495f5$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $59f00aac3a3495f5$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $59f00aac3a3495f5$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $59f00aac3a3495f5$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $59f00aac3a3495f5$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $59f00aac3a3495f5$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $59f00aac3a3495f5$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $59f00aac3a3495f5$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $59f00aac3a3495f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $59f00aac3a3495f5$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $59f00aac3a3495f5$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $59f00aac3a3495f5$export$be58b4326e23250f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts57"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$59f00aac3a3495f5$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$59f00aac3a3495f5$export$b993aa7bab57be12);
const $59f00aac3a3495f5$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts56"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$59f00aac3a3495f5$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$59f00aac3a3495f5$export$b993aa7bab57be12);
const $59f00aac3a3495f5$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts55"
})({
    name: "1h3cbh4",
    styles: "white-space:pre-wrap;word-break:break-all"
});
const $59f00aac3a3495f5$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts54"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $59f00aac3a3495f5$export$a16269f205a2f280 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts53"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $59f00aac3a3495f5$export$91b164375b8037b5 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts52"
})({
    name: "1v89jht",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $59f00aac3a3495f5$export$7291f9f954790243 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts51"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $59f00aac3a3495f5$export$ddce81e032b0736e = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ec5pts50"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});

});

parcelRegister("gBGO5", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $aaa5b38d181090fb$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $aaa5b38d181090fb$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $aaa5b38d181090fb$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $aaa5b38d181090fb$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $aaa5b38d181090fb$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $aaa5b38d181090fb$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $aaa5b38d181090fb$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $aaa5b38d181090fb$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $aaa5b38d181090fb$var$iconObjectOverrideStyles = null;
// TODO: remove this override behaviour for @atlaskit/icon
const $aaa5b38d181090fb$var$iconOverrideStyles = null;
const $aaa5b38d181090fb$var$iconWrapperStyles = null;
const $aaa5b38d181090fb$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$emojiWrapperStyles = null;
const $aaa5b38d181090fb$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$iconTitleWrapperStyles = null;
const $aaa5b38d181090fb$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$lozengeWrapperStyles = null;
const $aaa5b38d181090fb$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$lozengeBlockWrapperStyles = null;
const $aaa5b38d181090fb$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$rightIconPositionWrapperStyles = null;
const $aaa5b38d181090fb$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$iconPositionWrapperStyles = null;
const $aaa5b38d181090fb$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $aaa5b38d181090fb$var$iconEmptyWrapperStyles = null;
const $aaa5b38d181090fb$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("D38LN", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $8baf201a5ef1d288$export$52b4dfd89a6b3a1b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $djENT = parcelRequire("djENT");

var $8s3QS = parcelRequire("8s3QS");

var $fHpHg = parcelRequire("fHpHg");
const $8baf201a5ef1d288$export$52b4dfd89a6b3a1b = (props)=>(0, $fHpHg.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8s3QS.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djENT.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("djENT", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $acf75dd6bb888d0e$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $7lSuy = parcelRequire("7lSuy");

var $bWGt6 = parcelRequire("bWGt6");
function $acf75dd6bb888d0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $acf75dd6bb888d0e$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)((0, $7lSuy.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "1hde2gn",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px)"
});

});

parcelRegister("8s3QS", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $12cb853378bd3df3$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $12cb853378bd3df3$var$spinnerWrapperStyles = null;
const $12cb853378bd3df3$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("5fQ00", function(module, exports) {

let $3d36b06155bd5925$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3d36b06155bd5925$var$load("cVu76").then(()=>parcelRequire('4ZmEb'));

});

parcelRegister("cqis9", function(module, exports) {

let $90b63a1c88856b15$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $90b63a1c88856b15$var$load("h2MrD"),
    $90b63a1c88856b15$var$load("bYT2S"),
    $90b63a1c88856b15$var$load("awKc5")
]).then(()=>parcelRequire('5NKRA'));

});

parcelRegister("6WBjI", function(module, exports) {

let $50e51b37417606f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $50e51b37417606f8$var$load("h2MrD"),
    $50e51b37417606f8$var$load("bYT2S"),
    $50e51b37417606f8$var$load("iE3qa")
]).then(()=>parcelRequire('fBiTb'));

});


parcelRegister("iCSbq", function(module, exports) {

$parcel$export(module.exports, "mediaIdentifierMap", () => $0e48965bd4d10924$export$7da2d00ddd5627a6);
$parcel$export(module.exports, "getClipboardAttrs", () => $0e48965bd4d10924$export$92bef806f5be5d7c);
$parcel$export(module.exports, "MediaCard", () => $0e48965bd4d10924$export$a6543a2e3828db2c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $97iZx = parcelRequire("97iZx");

var $14XsJ = parcelRequire("14XsJ");
var $gZNqU = parcelRequire("gZNqU");
var $bo7ER = parcelRequire("bo7ER");

var $afuOi = parcelRequire("afuOi");

var $aDavv = parcelRequire("aDavv");
const $0e48965bd4d10924$export$7da2d00ddd5627a6 = new Map();
const $0e48965bd4d10924$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $97iZx.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $0e48965bd4d10924$export$cfff5eb155a82d30 extends (0, $5uXOq.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $0e48965bd4d10924$export$7da2d00ddd5627a6.has(id) || url && $0e48965bd4d10924$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $0e48965bd4d10924$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $0e48965bd4d10924$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $0e48965bd4d10924$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $0e48965bd4d10924$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $0e48965bd4d10924$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $14XsJ.default), {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($0e48965bd4d10924$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gZNqU.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...$0e48965bd4d10924$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $14XsJ.default), {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($0e48965bd4d10924$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {}, this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        }, this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bo7ER.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        }, /**
	 * We want to call provided `eventHandlers.media.onClick` when it's provided,
	 * but we also don't want to call it when it's a video and inline video player is enabled.
	 * This is due to consumers normally process this onClick call by opening media viewer and
	 * we don't want that to happened described above text.
	 */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $0e48965bd4d10924$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $0e48965bd4d10924$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $5uXOq.useContext)((0, $afuOi.MediaClientContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0e48965bd4d10924$export$cfff5eb155a82d30, {
        ...props,
        mediaClient: mediaClient
    });
};
const $0e48965bd4d10924$export$a6543a2e3828db2c = (0, $aDavv.withImageLoader)($0e48965bd4d10924$export$fae4803d1ca121c8);

});
parcelRegister("97iZx", function(module, exports) {

$parcel$export(module.exports, "filter", () => $a6d03044fa817856$export$3dea766d36a8935f);

var $iL33F = parcelRequire("iL33F");
function $a6d03044fa817856$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $iL33F.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("14XsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d9e5f722ad90c5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $bo7ER = parcelRequire("bo7ER");

var $5tDD0 = parcelRequire("5tDD0");
const $99d9e5f722ad90c5$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $99d9e5f722ad90c5$var$CardLoadingWithContext = ()=>{
    const props = (0, $5uXOq.useContext)($99d9e5f722ad90c5$var$MediaCardContext);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bo7ER.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $99d9e5f722ad90c5$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iV66f")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($99d9e5f722ad90c5$var$CardLoadingWithContext, {})
});
const $99d9e5f722ad90c5$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5tDD0.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($99d9e5f722ad90c5$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($99d9e5f722ad90c5$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$99d9e5f722ad90c5$var$CardLoader.preload = ()=>$99d9e5f722ad90c5$var$MediaCardWithMediaClientProvider.preload();
var $99d9e5f722ad90c5$export$2e2bcd8739ae039 = $99d9e5f722ad90c5$var$CardLoader;

});
parcelRegister("bo7ER", function(module, exports) {

$parcel$export(module.exports, "CardLoading", () => $ef659e110890002a$export$5d25853fd6bdf402);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i3kyC = parcelRequire("i3kyC");

var $27CIV = parcelRequire("27CIV");

var $clxo5 = parcelRequire("clxo5");
class $ef659e110890002a$export$5d25853fd6bdf402 extends (0, $5uXOq.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $i3kyC.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $27CIV.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("i3kyC", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $6315bfb78fa9c822$export$36acad525b1fb57b);
const $6315bfb78fa9c822$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("27CIV", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $c520a470f4dd5c35$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $80g7S = parcelRequire("80g7S");
const $c520a470f4dd5c35$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $80g7S.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("80g7S", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $815bd08ad69763e5$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dxYdi = parcelRequire("dxYdi");

const $815bd08ad69763e5$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $dxYdi.center), {
        background: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $a7f8c6b391092279$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $dxYdi.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("dxYdi", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $d4151627e7a8c366$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $d4151627e7a8c366$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $d4151627e7a8c366$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $d4151627e7a8c366$export$7a57f79000377ca2);

var $b4a3S = parcelRequire("b4a3S");
const $d4151627e7a8c366$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $d4151627e7a8c366$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $d4151627e7a8c366$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $d4151627e7a8c366$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $d4151627e7a8c366$export$7a57f79000377ca2 = `
  border-radius: ${(0, $b4a3S.borderRadius)()}px;
`;
const $d4151627e7a8c366$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${(0, $b4a3S.borderRadius)()}px;
  border-bottom-right-radius: ${(0, $b4a3S.borderRadius)()}px;
`;
const $d4151627e7a8c366$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});




parcelRegister("iV66f", function(module, exports) {

let $dc624820af246778$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dc624820af246778$var$load("cM9em"),
    $dc624820af246778$var$load("fr9NE"),
    $dc624820af246778$var$load("h2MrD"),
    $dc624820af246778$var$load("bYT2S"),
    $dc624820af246778$var$load("dwQ2h")
]).then(()=>parcelRequire('hSPU8'));

});


parcelRegister("gZNqU", function(module, exports) {

$parcel$export(module.exports, "CardError", () => $5360b0babf6873b2$export$f7f7efdefcc02999);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hpz4y = parcelRequire("hpz4y");

var $27CIV = parcelRequire("27CIV");

var $i3kyC = parcelRequire("i3kyC");
class $5360b0babf6873b2$export$f7f7efdefcc02999 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            size: 'medium'
        };
    }
    render() {
        const dimensions = (0, $i3kyC.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $27CIV.Wrapper), {
            dimensions: dimensions,
            children: this.icon
        });
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hpz4y.ErrorIcon), {
            size: size
        });
    }
}

});
parcelRegister("hpz4y", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", () => $debbcf3b333ed059$export$19bc16ee58e19b3d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $ghiZ4 = parcelRequire("ghiZ4");

var $8SpRY = parcelRequire("8SpRY");
class $debbcf3b333ed059$export$19bc16ee58e19b3d extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            size: 'small'
        };
    }
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $8SpRY.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghiZ4))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}

});
parcelRegister("ghiZ4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77723dece3c67bedf7bcbbec84e5d004>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd9cf5b7c464f88d$var$_react = $bd9cf5b7c464f88d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bd9cf5b7c464f88d$var$_warning = $bd9cf5b7c464f88d$var$_interopRequireDefault((parcelRequire("c0tV6")));

var $bd9cf5b7c464f88d$var$_warning2 = $bd9cf5b7c464f88d$var$_interopRequireDefault((parcelRequire("jFRXz")));
function $bd9cf5b7c464f88d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd9cf5b7c464f88d$var$WarningIcon = (props)=>/*#__PURE__*/ $bd9cf5b7c464f88d$var$_react.default.createElement($bd9cf5b7c464f88d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $bd9cf5b7c464f88d$var$_warning2.default
    }, props));
$bd9cf5b7c464f88d$var$WarningIcon.Name = 'WarningIconMigration';
var $bd9cf5b7c464f88d$var$_default = module.exports.default = $bd9cf5b7c464f88d$var$WarningIcon;

});
parcelRegister("jFRXz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e52bb3ecf1fcfe04$var$_react = $e52bb3ecf1fcfe04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e52bb3ecf1fcfe04$var$_warning = $e52bb3ecf1fcfe04$var$_interopRequireDefault((parcelRequire("c0tV6")));
function $e52bb3ecf1fcfe04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e52bb3ecf1fcfe04$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $e52bb3ecf1fcfe04$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $e52bb3ecf1fcfe04$var$_warning.default
    }));
$e52bb3ecf1fcfe04$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $e52bb3ecf1fcfe04$var$_default = module.exports.default = $e52bb3ecf1fcfe04$var$EditorWarningIcon;

});


parcelRegister("8SpRY", function(module, exports) {

$parcel$export(module.exports, "errorIconWrapperStyles", () => $1dc9caaf2cd41873$export$8dcf6b831a37de79);
function $1dc9caaf2cd41873$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1dc9caaf2cd41873$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};

});



parcelRegister("aDavv", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $58af98fd1bf68921$export$9b0f795b2e33f057);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
const $58af98fd1bf68921$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $58af98fd1bf68921$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $58af98fd1bf68921$export$9b0f795b2e33f057 = (Wrapped)=>{
    if ((0, $fHpHg.fg)('platform_editor_react18_phase2_v2') || (0, $fHpHg.fg)('platform_editor_react18_phase2_v2_extended')) return $58af98fd1bf68921$var$withImageLoaderNew(Wrapped);
    return $58af98fd1bf68921$export$3a0bcc6ff2e20f36(Wrapped);
};

});




//# sourceMappingURL=mediaInline.b8a6db39.js.map
